var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-8 offset-md-2"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}}),_c('button',{on:{"click":_vm.removeAllFiles}},[_vm._v("Remove All Files")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }